// Tracy AI 小妹 - AI 工具資料庫

export interface AITool {
  name: string;
  url: string;
  domain: string;
  category: string;
  desc: string;
  tags: string[];
  mention_count: number;
  videos: VideoRef[];
}

export interface VideoRef {
  title: string;
  url: string;
  published: string;
  views: string;
}

export interface Category {
  name: string;
  icon: string;
  color: string;
  gradient: string;
  bg: string;
  border: string;
  badgeBg: string;
  badgeText: string;
  desc: string;
  tools: AITool[];
}

export const CHANNEL_INFO = {
  name: 'Tracy AI 小妹',
  url: 'https://www.youtube.com/@tracyai小妹',
  description: '台灣最受歡迎的 AI 工具頻道，深入淺出介紹最新 AI 工具，讓你輕鬆掌握 AI 趨勢！',
  totalVideos: 195,
  totalTools: 47,
};

export const CATEGORIES_META: Record<string, Omit<Category, 'tools'>> = {
  'AI 影片生成': {
    name: 'AI 影片生成',
    icon: '🎬',
    color: '#f97316',
    gradient: 'linear-gradient(135deg, #f97316, #ef4444)',
    bg: 'rgba(249,115,22,0.08)',
    border: 'rgba(249,115,22,0.25)',
    badgeBg: 'rgba(249,115,22,0.15)',
    badgeText: '#fb923c',
    desc: '用 AI 生成電影級影片、動畫與 MV',
  },
  'AI 圖像生成': {
    name: 'AI 圖像生成',
    icon: '🎨',
    color: '#a855f7',
    gradient: 'linear-gradient(135deg, #a855f7, #ec4899)',
    bg: 'rgba(168,85,247,0.08)',
    border: 'rgba(168,85,247,0.25)',
    badgeBg: 'rgba(168,85,247,0.15)',
    badgeText: '#c084fc',
    desc: '用文字或圖片生成令人驚豔的視覺作品',
  },
  'AI 音樂 / 音效': {
    name: 'AI 音樂 / 音效',
    icon: '🎵',
    color: '#06b6d4',
    gradient: 'linear-gradient(135deg, #06b6d4, #0d9488)',
    bg: 'rgba(6,182,212,0.08)',
    border: 'rgba(6,182,212,0.25)',
    badgeBg: 'rgba(6,182,212,0.15)',
    badgeText: '#22d3ee',
    desc: '用 AI 創作音樂、歌曲與語音合成',
  },
  'AI 寫作 / 文字': {
    name: 'AI 寫作 / 文字',
    icon: '✍️',
    color: '#22c55e',
    gradient: 'linear-gradient(135deg, #22c55e, #10b981)',
    bg: 'rgba(34,197,94,0.08)',
    border: 'rgba(34,197,94,0.25)',
    badgeBg: 'rgba(34,197,94,0.15)',
    badgeText: '#4ade80',
    desc: '智能寫作、AI 對話與語言模型應用',
  },
  'AI 設計 / 簡報': {
    name: 'AI 設計 / 簡報',
    icon: '📊',
    color: '#f43f5e',
    gradient: 'linear-gradient(135deg, #f43f5e, #ec4899)',
    bg: 'rgba(244,63,94,0.08)',
    border: 'rgba(244,63,94,0.25)',
    badgeBg: 'rgba(244,63,94,0.15)',
    badgeText: '#fb7185',
    desc: '快速製作簡報、設計與視覺素材',
  },
  'AI 搜尋 / 研究': {
    name: 'AI 搜尋 / 研究',
    icon: '🔍',
    color: '#3b82f6',
    gradient: 'linear-gradient(135deg, #3b82f6, #6366f1)',
    bg: 'rgba(59,130,246,0.08)',
    border: 'rgba(59,130,246,0.25)',
    badgeBg: 'rgba(59,130,246,0.15)',
    badgeText: '#60a5fa',
    desc: '深度搜尋、研究與知識整合工具',
  },
  'AI 工作流程': {
    name: 'AI 工作流程',
    icon: '⚙️',
    color: '#f59e0b',
    gradient: 'linear-gradient(135deg, #f59e0b, #d97706)',
    bg: 'rgba(245,158,11,0.08)',
    border: 'rgba(245,158,11,0.25)',
    badgeBg: 'rgba(245,158,11,0.15)',
    badgeText: '#fbbf24',
    desc: 'AI Agents 與自動化工作流程工具',
  },
  'AI 其他工具': {
    name: 'AI 其他工具',
    icon: '🤖',
    color: '#64748b',
    gradient: 'linear-gradient(135deg, #64748b, #6b7280)',
    bg: 'rgba(100,116,139,0.08)',
    border: 'rgba(100,116,139,0.25)',
    badgeBg: 'rgba(100,116,139,0.15)',
    badgeText: '#94a3b8',
    desc: '更多創新 AI 應用與實用工具',
  },
};

export const CATEGORIES_ORDER = [
  'AI 影片生成',
  'AI 圖像生成',
  'AI 音樂 / 音效',
  'AI 寫作 / 文字',
  'AI 設計 / 簡報',
  'AI 搜尋 / 研究',
  'AI 工作流程',
  'AI 其他工具',
];

export const ALL_TOOLS: AITool[] = [
  // ==================== AI 影片生成 ====================
  {
    name: 'Skywork AI 天工',
    url: 'https://skywork.ai',
    domain: 'skywork.ai',
    category: 'AI 影片生成',
    desc: '超級智能體，整合 Sora/Veo3/Kling，一站式 AI 創作平台，支援影片、簡報、播客',
    tags: ['影片生成', '圖像生成', '簡報', '播客', 'AI Agent'],
    mention_count: 7,
    videos: [
      { title: '一個工具取代全部！天工 Skywork 超級智能體AI Agents！報告、PPT、海報、影片、播客一次全包', url: 'https://www.youtube.com/watch?v=-hCVBmW0sDE', published: '12 days ago', views: '8.4K views' },
    ],
  },
  {
    name: 'MagicLight AI',
    url: 'https://www.magiclight.ai',
    domain: 'magiclight.ai',
    category: 'AI 影片生成',
    desc: '一鍵生成音樂影片與兒童動畫，整合 Suno AI + Hailuo/Kling 模型，角色高度一致',
    tags: ['兒童動畫', '音樂影片', 'MV', '一鍵生成'],
    mention_count: 6,
    videos: [
      { title: 'MagicLight AI音樂影片Music Video！！一個想法秒出「音樂+MV+角色一致」完整影片', url: 'https://www.youtube.com/watch?v=IhoOPGK4YQs', published: '2 months ago', views: '845 views' },
    ],
  },
  {
    name: 'Cremi AI',
    url: 'https://cremi.ai',
    domain: 'cremi.ai',
    category: 'AI 影片生成',
    desc: '整合 Runway/Veo3/Sora/Kling 的 AI 音樂影片平台，支援嘴型同步與動作控制',
    tags: ['MV製作', '音樂影片', '動作控制', '嘴型同步'],
    mention_count: 4,
    videos: [
      { title: 'Cremi AI 讓你的音樂「動」起來！整合Sora、Veo3、Kling，輕鬆打造千萬點擊MV！', url: 'https://www.youtube.com/watch?v=khvpWel_sLg', published: '10 days ago', views: '1.3K views' },
    ],
  },
  {
    name: 'Freebeat AI',
    url: 'https://freebeat.ai',
    domain: 'freebeat.ai',
    category: 'AI 音樂 / 音效',
    desc: 'AI 音樂生成工具，支援多種音樂風格，輕鬆創作專業級音樂',
    tags: ['音樂生成', '多風格', '免費試用'],
    mention_count: 4,
    videos: [],
  },
  {
    name: 'Tensor.Art',
    url: 'https://tensor.art',
    domain: 'tensor.art',
    category: 'AI 圖像生成',
    desc: 'Stable Diffusion 線上繪圖平台，支援多種 AI 繪圖模型，免費使用',
    tags: ['Stable Diffusion', '線上繪圖', '模型分享', '免費'],
    mention_count: 4,
    videos: [],
  },
  {
    name: 'Tenorshare AI',
    url: 'https://www.tenorshare.tw',
    domain: 'tenorshare.tw',
    category: 'AI 其他工具',
    desc: 'AI 手機工具套件，包含資料恢復、螢幕解鎖等實用功能',
    tags: ['手機工具', '資料恢復', 'AI輔助'],
    mention_count: 4,
    videos: [],
  },
  {
    name: 'OpenCreator',
    url: 'https://opencreator.io',
    domain: 'opencreator.io',
    category: 'AI 影片生成',
    desc: 'AI 影片創作平台，支援多種頂尖 AI 模型，輕鬆製作高品質影片',
    tags: ['影片生成', '創作工具', '多模型'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'NanoPhoto AI',
    url: 'https://nanophoto.ai',
    domain: 'nanophoto.ai',
    category: 'AI 影片生成',
    desc: 'Nano Banana 系列 AI 圖片與影片生成工具，支援高品質畫面輸出',
    tags: ['圖片生成', '影片生成', 'Nano Banana'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'Manus AI',
    url: 'https://manus.im',
    domain: 'manus.im',
    category: 'AI 搜尋 / 研究',
    desc: '全球首個通用 AI Agent，自主完成複雜研究任務，深度分析與報告生成',
    tags: ['AI Agent', '自主任務', '深度研究', '報告生成'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'MiniMax',
    url: 'https://www.minimax.io',
    domain: 'minimax.io',
    category: 'AI 影片生成',
    desc: '字節跳動 MiniMax 平台，整合 Hailuo 影片生成，支援 AI 音頻創作',
    tags: ['影片生成', 'Hailuo', '字節跳動', 'AI音頻'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'Shakker AI',
    url: 'https://www.shakker.ai',
    domain: 'shakker.ai',
    category: 'AI 圖像生成',
    desc: 'AI 繪圖平台，支援多種風格與模型，介面友善直觀',
    tags: ['AI繪圖', '風格多樣', '介面友善'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'HeyGen',
    url: 'https://www.heygen.com',
    domain: 'heygen.com',
    category: 'AI 影片生成',
    desc: 'AI 數字人影片生成，支援多語言配音與形象克隆，行銷必備工具',
    tags: ['數字人', '多語言配音', '形象克隆', '行銷影片'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'Genmo AI (Mochi)',
    url: 'https://alpha.genmo.ai',
    domain: 'alpha.genmo.ai',
    category: 'AI 影片生成',
    desc: 'Mochi AI 影片生成模型，以高品質流暢動態影片著稱',
    tags: ['影片生成', 'Mochi模型', '流暢動態'],
    mention_count: 3,
    videos: [],
  },
  {
    name: 'TopView AI',
    url: 'https://www.topview.ai',
    domain: 'topview.ai',
    category: 'AI 影片生成',
    desc: 'AI 廣告影片自動生成平台，一鍵製作爆款電商短影音',
    tags: ['廣告影片', '電商行銷', '短影音', '一鍵生成'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'Supawork AI',
    url: 'https://supawork.ai',
    domain: 'supawork.ai',
    category: 'AI 圖像生成',
    desc: 'AI 專業形象照生成工具，輕鬆將普通照片升級為商務形象照',
    tags: ['形象照', '商務照片', 'AI修圖', '職業形象'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'Fotor',
    url: 'https://fotor.me',
    domain: 'fotor.me',
    category: 'AI 圖像生成',
    desc: 'AI 圖片編輯與設計工具，整合 AI 繪圖、修圖與設計功能',
    tags: ['圖片編輯', '設計工具', 'AI繪圖', 'AI修圖'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'Picma (MagicTiger)',
    url: 'https://picma.magictiger.ai',
    domain: 'picma.magictiger.ai',
    category: 'AI 圖像生成',
    desc: 'AI 圖像生成與美化工具，提升照片品質與視覺效果',
    tags: ['圖像生成', '圖片美化', '畫質提升'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'GenTube',
    url: 'https://www.gentube.app',
    domain: 'gentube.app',
    category: 'AI 影片生成',
    desc: 'AI 影片生成應用，輕鬆創作短影音內容',
    tags: ['影片生成', '短影音', 'YouTube'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'ChatGPT',
    url: 'https://chatgpt.com',
    domain: 'chatgpt.com',
    category: 'AI 寫作 / 文字',
    desc: 'OpenAI 旗下全球最知名的 AI 對話工具，GPT-4o 驅動，適合各種寫作任務',
    tags: ['AI對話', '寫作輔助', 'GPT-4o', '最知名'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'OpenAI',
    url: 'https://openai.com',
    domain: 'openai.com',
    category: 'AI 寫作 / 文字',
    desc: 'ChatGPT、GPT 系列、Sora、DALL-E 的開發商，AI 領域頂尖研究機構',
    tags: ['GPT', 'DALL-E', 'Sora', 'AI研究'],
    mention_count: 2,
    videos: [],
  },
  {
    name: 'VDraw AI',
    url: 'https://vdraw.ai',
    domain: 'vdraw.ai',
    category: 'AI 影片生成',
    desc: 'AI 繪圖與影片生成工具，輕鬆將創意轉化為視覺作品',
    tags: ['繪圖', '影片生成', '創意工具'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Animon AI',
    url: 'https://www.animon.ai',
    domain: 'animon.ai',
    category: 'AI 影片生成',
    desc: 'AI 動畫生成工具，讓靜態圖片動起來',
    tags: ['動畫生成', '圖片轉動畫'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'ProActor AI',
    url: 'https://proactor.ai',
    domain: 'proactor.ai',
    category: 'AI 影片生成',
    desc: 'AI 影片創作與角色生成工具，維持角色一致性',
    tags: ['影片生成', '角色一致性', 'AI演員'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Filmora',
    url: 'https://filmora.wondershare.net',
    domain: 'filmora.wondershare.net',
    category: 'AI 影片生成',
    desc: 'Wondershare Filmora AI 影片剪輯與創作工具，功能全面易上手',
    tags: ['影片剪輯', 'AI特效', '創作工具', 'Wondershare'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Edimakor',
    url: 'https://edimakor.hitpaw.tw',
    domain: 'edimakor.hitpaw.tw',
    category: 'AI 影片生成',
    desc: '整合 Sora/Kling/Veo3 的全能 AI 影片創作平台，告別多平台訂閱',
    tags: ['影片生成', '影片編輯', 'Sora', 'Kling', 'Veo3'],
    mention_count: 1,
    videos: [
      { title: '2026 最強 AI 影片工具Edimakor 告別多平台訂閱！打造電影感戰鬥、AI音樂', url: 'https://www.youtube.com/watch?v=bXuzPDjspUQ', published: '10 days ago', views: '1.4K views' },
    ],
  },
  {
    name: 'Vheer',
    url: 'https://vheer.com',
    domain: 'vheer.com',
    category: 'AI 影片生成',
    desc: 'AI 影片生成與創作工具',
    tags: ['影片生成', 'AI創作'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Novi AI',
    url: 'https://download.imyfone.com',
    domain: 'download.imyfone.com',
    category: 'AI 影片生成',
    desc: 'Novi AI 整合 Sora2/Veo3/Kling 的終身買斷影片平台，一次訂閱多模型',
    tags: ['影片生成', '終身方案', '多模型', 'iMyFone'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'MiniMax Agent',
    url: 'https://agent.minimax.io',
    domain: 'agent.minimax.io',
    category: 'AI 影片生成',
    desc: 'MiniMax AI Agent 對話與任務處理平台',
    tags: ['AI Agent', 'AI對話', 'MiniMax'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Hedra',
    url: 'https://www.hedra.com',
    domain: 'hedra.com',
    category: 'AI 影片生成',
    desc: 'AI 說話人像與影片生成工具，讓照片開口說話',
    tags: ['數字人', '說話人像', '影片生成'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Nim Video',
    url: 'https://nim.video',
    domain: 'nim.video',
    category: 'AI 影片生成',
    desc: 'AI 影片創作探索平台，發現最新影片生成技術',
    tags: ['影片生成', '創作工具', 'AI探索'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Hailuo AI',
    url: 'https://hailuoai.video',
    domain: 'hailuoai.video',
    category: 'AI 影片生成',
    desc: 'MiniMax 旗下海螺 AI 影片生成工具，擅長生成電影級畫面',
    tags: ['影片生成', '電影級', 'MiniMax', '海螺AI'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 圖像生成 ====================
  {
    name: 'Camika',
    url: 'https://www.camika.ai',
    domain: 'camika.ai',
    category: 'AI 圖像生成',
    desc: 'AI 角色創作遊戲化平台，72 種繪圖風格，支援漫畫、動畫、LINE 貼圖',
    tags: ['角色創作', '漫畫', 'LINE貼圖', '遊戲化', '72種風格'],
    mention_count: 1,
    videos: [
      { title: 'Camika 把AI繪圖玩成角色養成遊戲AI 捏臉，創作漫畫、動畫、表情包一站搞定！', url: 'https://www.youtube.com/watch?v=IJxf1jfGOQU', published: '6 days ago', views: '337 views' },
    ],
  },
  {
    name: 'AIEnhancer',
    url: 'https://aienhancer.ai',
    domain: 'aienhancer.ai',
    category: 'AI 圖像生成',
    desc: '免費 AI 修圖、去背、繪圖平台，整合 Nano Banana / FLUX 模型，全功能免費',
    tags: ['修圖', '去背', '免費', 'Nano Banana', 'FLUX'],
    mention_count: 1,
    videos: [
      { title: 'AIEhancer 讓你白嫖Nano Banana、FLUX等AI模型，修圖、去背、影片去水印、Logo設計', url: 'https://www.youtube.com/watch?v=AxVtzdGF0ns', published: '1 month ago', views: '877 views' },
    ],
  },
  {
    name: 'Morisot AI',
    url: 'https://morisot.ai',
    domain: 'morisot.ai',
    category: 'AI 圖像生成',
    desc: 'AI 藝術圖像生成工具，創作博物館級別的藝術作品',
    tags: ['AI藝術', '圖像生成', '藝術風格'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Prome AI',
    url: 'https://www.promeai.pro',
    domain: 'promeai.pro',
    category: 'AI 圖像生成',
    desc: 'AI 建築設計與圖像生成工具，室內設計師必備',
    tags: ['建築設計', '室內設計', 'AI繪圖', '專業設計'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'PicLumen',
    url: 'https://www.piclumen.com',
    domain: 'piclumen.com',
    category: 'AI 圖像生成',
    desc: 'AI 圖像生成工具，支援多種風格與創意主題',
    tags: ['圖像生成', '多種風格', '創意主題'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Dzine AI',
    url: 'https://www.dzine.ai',
    domain: 'dzine.ai',
    category: 'AI 圖像生成',
    desc: 'AI 設計與圖像創作平台，輕鬆生成品牌視覺素材',
    tags: ['設計', '圖像生成', '品牌視覺'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'CivitAI',
    url: 'https://civitai.com',
    domain: 'civitai.com',
    category: 'AI 圖像生成',
    desc: 'Stable Diffusion 模型社群，全球最大 AI 繪圖模型分享與下載平台',
    tags: ['模型社群', 'Stable Diffusion', '開源模型', '模型分享'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'OpenPoses',
    url: 'https://openposes.com',
    domain: 'openposes.com',
    category: 'AI 圖像生成',
    desc: 'AI 姿勢參考工具，輔助 AI 繪圖精準控制角色姿勢',
    tags: ['姿勢參考', 'AI繪圖輔助', '角色姿勢'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 音樂 ====================
  {
    name: 'Sonauto',
    url: 'https://sonauto.ai',
    domain: 'sonauto.ai',
    category: 'AI 音樂 / 音效',
    desc: 'AI 音樂生成平台，操作簡單，支援多種音樂類型',
    tags: ['音樂生成', '簡單易用', '多種類型'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Suno',
    url: 'https://suno.com',
    domain: 'suno.com',
    category: 'AI 音樂 / 音效',
    desc: '全球最熱門的 AI 音樂生成工具，文字描述即可生成完整歌曲含歌詞',
    tags: ['音樂生成', '歌詞生成', '熱門工具', '全球最佳'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 寫作 ====================
  {
    name: 'NinjaChat AI',
    url: 'https://ninjachat.ai',
    domain: 'ninjachat.ai',
    category: 'AI 寫作 / 文字',
    desc: '整合多種 AI 模型的對話平台，一個帳號使用多個 AI',
    tags: ['AI對話', '多模型整合', '一站使用'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 設計 ====================
  {
    name: 'Gamma',
    url: 'https://gamma.app',
    domain: 'gamma.app',
    category: 'AI 設計 / 簡報',
    desc: 'AI 一鍵生成精美簡報、文件與網頁，設計感出眾，取代 PowerPoint',
    tags: ['簡報', 'AI設計', '文件生成', '取代PPT'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 研究 ====================
  {
    name: 'ReadKidz',
    url: 'https://www.readkidz.com',
    domain: 'readkidz.com',
    category: 'AI 搜尋 / 研究',
    desc: 'AI 兒童閱讀輔助工具，幫助孩子提升閱讀理解能力',
    tags: ['兒童教育', '閱讀輔助', 'AI教育'],
    mention_count: 1,
    videos: [],
  },
  // ==================== AI 工作流程 ====================
  {
    name: 'Hugging Face',
    url: 'https://huggingface.co',
    domain: 'huggingface.co',
    category: 'AI 工作流程',
    desc: '全球最大 AI 模型開源社群，提供數萬個 AI 模型與 Spaces 應用平台',
    tags: ['開源模型', 'Spaces', 'AI社群', '模型平台'],
    mention_count: 1,
    videos: [],
  },
  {
    name: 'Chatbase',
    url: 'https://www.chatbase.co',
    domain: 'chatbase.co',
    category: 'AI 工作流程',
    desc: '用自己的資料訓練 AI 客服機器人，快速建立企業專屬 AI 助手',
    tags: ['客服機器人', 'AI訓練', '企業應用', 'RAG'],
    mention_count: 1,
    videos: [],
  },
];

// 按類別分組
export function getToolsByCategory(): Record<string, AITool[]> {
  const result: Record<string, AITool[]> = {};
  for (const cat of CATEGORIES_ORDER) {
    result[cat] = ALL_TOOLS.filter(t => t.category === cat)
      .sort((a, b) => b.mention_count - a.mention_count);
  }
  return result;
}

export function searchTools(query: string): AITool[] {
  const q = query.toLowerCase().trim();
  if (!q) return ALL_TOOLS;
  return ALL_TOOLS.filter(t =>
    t.name.toLowerCase().includes(q) ||
    t.desc.toLowerCase().includes(q) ||
    t.tags.some(tag => tag.toLowerCase().includes(q)) ||
    t.category.toLowerCase().includes(q)
  );
}
